export const buildDiscoverLink = (
    articleCategory?: string,
    articleSlug?: string
) => {
    if (!articleCategory || !articleSlug) {
        return `/discover/`;
    }

    return `/discover/${articleCategory}/${articleSlug}/`;
};
